// RenderFunctional
import FullFunctional from './variants/FullFunctional';
import MediumFunctional from './variants/MediumFunctional';
import AddFunctional from './variants/AddFunctional';
import DefaultFunctional from './variants/DefaultFunctional';

const RenderFunctional = (props) => {
    switch (props.type) {
        case 'fullFunctional':
            return <FullFunctional {...props} />;

        case 'mediumFunctional':
            return <MediumFunctional view={props.view} />;

        case 'add':
            return <AddFunctional buttonText={props.buttonText} handleShow={props.handleShow} />;

        case 'minimalFunctional':
            return null;

        default:
            return (
                <DefaultFunctional
                    additionalData={props.additionalData}
                    noneSelectUpdatedPictures={props.noneSelectUpdatedPictures}
                    dispatchAction={props.dispatchAction}
                    setPageNumber={props.setPageNumber}
                    setPageSize={props.setPageSize}
                    pageNumber={props.pageNumber}
                    pageSize={props.pageSize}
                    productSort={props.productSort}
                    get={props.get}
                    search={props.search}
                    typeSort={props.typeSort}
                    sortType={props.sortType}
                    sortSearch={props.sortSearch}
                    setSearchMainName={props.setSearchMainName}
                />
            );
    }
};

export default RenderFunctional;